module.exports = __webpack_public_path__ + "static/media/overview-invitees.c2f63200.svg";